// Product catalog for ACT Merch

const SHIRT_SIZES = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];

export const products = [
  {
    slug: 'coffee-and-jesus-club',
    name: 'Coffee & Jesus Club Tee',
    category: 'Shirt',
    price: 23,
    image:
      'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/z40bx86e_Coffee%20%26%20Jesus%20Club.png',
    description:
      'Vintage-inspired oversized tee featuring the Coffee & Jesus Club design front and back. Screen-printed on comfort-color heavyweight cotton.',
    highlights: [
      'Front chest and full back print',
      '100% ring-spun comfort-color cotton',
      'Relaxed, oversized fit',
    ],
    sizes: SHIRT_SIZES,
  },
  {
    slug: 'act-tee',
    name: 'ACT T-Shirt',
    category: 'Shirt',
    price: 23,
    image:
      'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/bjelkoo7_ACT%20T-Shirt.png',
    description:
      'Repping ACT bold and simple. Front chest logo with a large hand-painted "Apostolic Christ Tabernacle" graphic on the back.',
    highlights: [
      'Front left-chest ACT mark',
      'Bold back print, mineral-washed black',
      'Premium heavyweight tee',
    ],
    sizes: SHIRT_SIZES,
  },
  {
    slug: 'hands-feet-of-jesus',
    name: 'Hands & Feet of Jesus Tee',
    category: 'Shirt',
    price: 23,
    image:
      'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/c4cspw3n_Hands%20and%20Feet%20of%20Jesus.png',
    description:
      'James 2:14-17 inspired tee. "Being the hands and feet of Jesus" — our call as a church family.',
    highlights: [
      'Front chest "ACT for the Community" mark',
      'Full back print with James 2:14-17 reference',
      'Forest-green mineral-washed premium tee',
    ],
    sizes: SHIRT_SIZES,
  },
  {
    slug: 'jesus-is-king-hat',
    name: 'Jesus Is King Snapback',
    category: 'Hat',
    price: 35,
    image:
      'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/ddsb7648_King%20Jesus%20hat.png',
    description:
      'Premium two-tone corduroy snapback with embroidered "JESUS IS KING." Cream crown, crimson brim.',
    highlights: [
      'Structured 5-panel corduroy snapback',
      'Raised embroidered lettering',
      'One size fits most',
    ],
    sizes: ['One Size'],
  },
  {
    slug: 'raising-disciples-hat',
    name: 'Raising Disciples Snapback',
    category: 'Hat',
    price: 35,
    image:
      'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/jzdcbslx_Raising%20Disciples%20Hat.png',
    description:
      'A reminder of our mission — raising disciples for Christ. Premium two-tone corduroy snapback with bold embroidery.',
    highlights: [
      'Structured 5-panel corduroy snapback',
      'Raised embroidered lettering',
      'One size fits most',
    ],
    sizes: ['One Size'],
  },
  {
    slug: 'yhwh-hat',
    name: 'YHWH Snapback',
    category: 'Hat',
    price: 35,
    image:
      'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/d8y0hhb9_IMG_0195.png',
    description:
      'The sacred name embroidered in bold. Cream corduroy crown with a rich brown brim — premium two-tone snapback made to be worn every day.',
    highlights: [
      'Structured 5-panel corduroy snapback',
      'Cream crown · brown brim',
      'Raised embroidered "YHWH" lettering',
      'One size fits most',
    ],
    sizes: ['One Size'],
  },
];

export const findProduct = (slug) => products.find((p) => p.slug === slug);
